import { SelectPicker } from "rsuite";
import { useTranslation } from "react-i18next";
import "./OrderFilters.css";
import { serviceRatingObjArr } from "../../../core/config/AppConstants";

const OrderServiceRateItems = ({
  onServiceItemChange,
  orderServiceItems = [],
  setStopSubmit,
}: {
  onServiceItemChange?: Function;
  orderServiceItems?: any[];
  setStopSubmit?: Function;
}) => {
  const { t } = useTranslation();

  const updateItemRating = (index: number, value: number) => {
    const updatedItems = orderServiceItems.map((item, i) =>
      i === index ? { ...item, item_service_rating: value } : item,
    );
    onServiceItemChange?.(updatedItems);
  };

  return (
    <div>
      <div className="service-items-grid">
        {orderServiceItems?.map((sitem: any, index: number) => {
          const fieldSuffix = `${sitem.product_id}_${sitem.qty_no}_${index}`;

          return (
            <div className="service-item" key={fieldSuffix}>
              <label>
                {sitem.item_name} {sitem.qty_no}
              </label>

              <SelectPicker
                data={serviceRatingObjArr}
                valueKey="value"
                labelKey="label"
                value={sitem.item_service_rating?.toString() ?? null}
                onChange={(value) => updateItemRating(index, value)}
                cleanable
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderServiceRateItems;
